var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.6,
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64821 11.3587C7.69578 11.4043 7.75189 11.44 7.8133 11.4638C7.87318 11.4902 7.93793 11.5039 8.0034 11.5039C8.06887 11.5039 8.13362 11.4902 8.1935 11.4638C8.25491 11.44 8.31101 11.4043 8.35859 11.3587L10.3597 9.35763C10.4539 9.26343 10.5068 9.13566 10.5068 9.00244C10.5068 8.86921 10.4539 8.74145 10.3597 8.64724C10.2655 8.55304 10.1377 8.50012 10.0045 8.50012C9.87126 8.50012 9.74349 8.55304 9.64929 8.64724L8.50367 9.79787V5.00027C8.50367 4.86759 8.45096 4.74034 8.35714 4.64652C8.26332 4.5527 8.13608 4.5 8.0034 4.5C7.87072 4.5 7.74347 4.5527 7.64965 4.64652C7.55583 4.74034 7.50313 4.86759 7.50313 5.00027V9.79787L6.35751 8.64724C6.31086 8.6006 6.25549 8.5636 6.19454 8.53835C6.1336 8.51311 6.06828 8.50012 6.00231 8.50012C5.93635 8.50012 5.87103 8.51311 5.81009 8.53835C5.74914 8.5636 5.69377 8.6006 5.64712 8.64724C5.60048 8.69389 5.56348 8.74926 5.53823 8.81021C5.51299 8.87115 5.5 8.93647 5.5 9.00244C5.5 9.0684 5.51299 9.13372 5.53823 9.19466C5.56348 9.25561 5.60048 9.31098 5.64712 9.35763L7.64821 11.3587Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4d5b363b9521f8e8e46f9997b6fbd0c6.svg";
export { ForwardRef as ReactComponent };